import React from "react";
import TicketEditionIState, {
  TicketEditionIProps,
} from "./TicketEdition.models";
import "./TicketEdition.scss";
import SupportDepartmentService from "../../../../services/supporter/SupportDepartmentService";
import NotifyContext from "../../../../contexts/NotifyContext";
import TicketCenterService from "../../../../services/management/TicketCenterService";
import DepartmentType from "../../../../models/interfaces/management/DepartmentType";
import { NavLink } from "react-router-dom";
export default class TicketEdition extends React.PureComponent<
  TicketEditionIProps,
  TicketEditionIState
> {
  supportDepartmentService: SupportDepartmentService;
  ticketCenterService: TicketCenterService;
  static contextType = NotifyContext;
  constructor(props: any) {
    super(props);
    this.supportDepartmentService = new SupportDepartmentService();
    this.ticketCenterService = new TicketCenterService();
    this.state = {
      department: {
        title: "",
        value: "",
      },
      entity: {
        title: "",
        description: "",
        supportTicketHandlerId: "",
      },
    };
  }

  componentDidMount() {
    this.getDepartment();
    this.getDepartmentId();
  }

  getDepartmentId() {
    let self = this;

    self.ticketCenterService
      .getDepartmentIdByDepartmentType(DepartmentType.InstituteStaff)
      .then(function (response) {
        self.setState((prevState) => {
          return {
            entity: { ...prevState.entity, supportDepartmentID: response },
          };
        });
      });
  }

  getDepartment() {
    let self = this;
    let department: any;

    self.supportDepartmentService.getTitleValue().then(function (response) {
      department = response.filter(
        (item) => item.id === self.props.inComing
      )[0];
      self.setState((prevState) => {
        return {
          department: department,
          entity: {
            ...prevState.entity,
            supportTicketHandlerId: department.value,
          },
        };
      });
    });
  }

  clear() {
    this.setState({
      department: {
        title: "",
        value: "",
      },
      entity: {
        title: "",
        description: "",
        supportTicketHandlerId: "",
      },
    });
  }

  redirect() {}

  create() {
    let self = this;
    let { entity } = self.state;

    if (entity.title === "")
      return self.context.showNotify({
        badge: "danger",
        title: "رخداد خطا",
        description: "متن عنوان نمیتواند خالی باشد",
      });
    else if (entity.description === "")
      return self.context.showNotify({
        badge: "danger",
        title: "رخداد خطا",
        description: "متن توضیحات نمیتواند خالی باشد",
      });

    self.ticketCenterService.createTicket(entity).then(function (response) {
      if (response !== undefined)
        self.context.showNotify({
          badge: "success",
          title: "ثبت تیکت",
          description: "تیکت با موفقیت ثبت شد",
        });
      else
        self.context.showNotify({
          badge: "danger",
          title: "نا موفق",
          description: "رخداد خطا",
        });
    });

    self.clear();
  }

  render(): React.ReactNode {
    let { department, entity } = this.state;
    return (
      <>
        <div
          className="content-menu ticket-edition-area"
          style={{ height: "91vh" }}
        >
          <div className="tk-aling-right tk-padding-top">
            <div className="col-12 departemant">
              <div>نوع پشتیبانی : {department.title}</div>
            </div>
            <div className="col-12">
              <label>عنوان تیکت</label>
              <input
                onChange={(e) =>
                  this.setState((prevState) => {
                    return {
                      entity: { ...prevState.entity, title: e.target.value },
                    };
                  })
                }
                type="text"
                value={entity.title}
                className="form-control"
                placeholder="عنوان"
              />
            </div>
            <div className="col-12">
              <label>متن تیکت</label>
              <textarea
                onChange={(e) =>
                  this.setState((prevState) => {
                    return {
                      entity: {
                        ...prevState.entity,
                        description: e.target.value,
                      },
                    };
                  })
                }
                value={entity.description}
                style={{ resize: "none" }}
                className="form-control"
                placeholder="متن تیکت"
              />
            </div>
          </div>
          <div className="mt-5">
            <div className="col-12">
              <NavLink to={"/TicketList"}>
                <button
                  type="submit"
                  className="btn btn-primary tk-full-width"
                  onClick={() => this.create()}
                >
                  ثبت تیکت
                </button>
              </NavLink>
            </div>
          </div>
        </div>
      </>
    );
  }
}
